<template>
  <div class="prjRole">
    <div class="prjRole__layout-left">
      <roleTree
        @node-click="nodeClick"
        @editCategory="editCategory"
        :enableModifiy="true"
        ref="roleTree"
      >
        <el-dropdown
          class="dropdown"
          v-if="addPrjRoleUserConfig || addSpecConfig"
        >
          <span class="el-dropdown-link">
            <i class="el-icon-circle-plus"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="el-icon-user-solid"
              @click.native="newRole"
              v-if="addPrjRoleUserConfig"
              >新建角色</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-menu"
              @click.native="newCate"
              v-if="addSpecConfig"
              >新建分类</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </roleTree>
    </div>
    <div class="prjRole__layout-right">
      <div class="prjRole__layout-right-tag" v-if="false">
        <div class="header">
          <span>关联标签</span>
          <el-button size="small" type="primary" plain>+新建标签</el-button>
        </div>
      </div>
      <div class="prjRole__layout-right-perm">
        <div class="header">
          <span>权限分配</span>
        </div>
        <div class="detail">
          <div class="hasData" v-if="!!node">
            <template v-if="!node.isCata">
              <div
                v-loading="tableLoading"
                class="role-auth-project-list"
                element-loading-text="数据加载中..."
              >
                <el-table
                  :indent="16"
                  :tree-props="{ children: 'childList' }"
                  :data="moduleTree"
                  :show-header="false"
                  row-key="permissionId"
                  default-expand-all
                  border
                  height="100%"
                >
                  <template slot="empty">
                    <img :src="require('@/CommonDP/assets/暂无数据.png')" />
                    <p style="font-size: 16px; color: #000">暂无数据</p>
                  </template>

                  <el-table-column class-name="table-module-name" width="260px">
                    <template #default="{ row }">
                      <el-checkbox
                        v-model="row.isChecked"
                        :true-label="1"
                        :false-label="0"
                        :indeterminate="!!row.indeterminate"
                        @change="checkPermissionClass(row)"
                      >
                        {{ row.permissionName }}
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column class-name="table-module-name">
                    <template #default="{ row }">
                      <div
                        v-for="(item, index) in row.buttonList"
                        :key="index"
                        style="margin-right: 30px; width: 150px"
                      >
                        <el-checkbox
                          v-model="item.isChecked"
                          :true-label="1"
                          :false-label="0"
                          @change="checkPermissionButton(item)"
                        >
                          {{ item.permissionName }}
                        </el-checkbox>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div
                class="role-auth-modules-footer"
                v-if="Array.isArray(moduleTree) && moduleTree.length > 0"
              >
                <el-button
                  v-if="node.roleName != '系统管理员'"
                  :disabled="isDisabled"
                  type="primary"
                  size="small"
                  @click="submitModulesHandler()"
                  >提交权限</el-button
                >
              </div>
            </template>
            <template v-else>
              <span
                >请选择<b>{{ node.roleName }}</b
                >下角色设置权限</span
              >
            </template>
          </div>
          <template v-else>
            <div class="flexLayout">
              <img
                :src="require('@/CommonDP/assets/暂无数据.png')"
                alt=""
                srcset=""
              />
              <span>请选择分类/角色</span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <el-dialog title="新建角色" :visible.sync="roleDialog" width="400px">
      <div class="submitForm" v-loading="roleDialogLoading">
        <span class="label">请输入角色名称</span>
        <el-input
          size="small"
          v-model="submitRole.roleName.$value"
          placeholder=""
          maxlength="30"
          show-word-limit
        ></el-input>

        <span class="label">请选择所属分类</span>
        <el-select
          v-model="submitRole.spec.$value"
          filterable
          clearable
          size="small"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in dict.treeList"
            :key="index"
            :label="item.roleName"
            :value="item.roleID"
          >
          </el-option>
        </el-select>

        <span class="label">业态</span>
        <el-select
          v-model="roleFormatCompute"
          filterable
          clearable
          multiple
          disabled
          size="small"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in dict.formatList"
            :key="index"
            :label="item.cnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="label">角色归属</span>
        <el-select
          v-model="roleBelongedCompute"
          size="small"
          disabled
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in dict.roleList"
            :key="index"
            :label="item.cnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleDialog = false">取 消</el-button>
        <el-button type="primary" @click="addNewRole">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新建分类" :visible.sync="cateDialog" width="400px">
      <div class="submitForm" v-loading="cateDialogLoading">
        <span class="label">请输入分类名称</span>
        <el-input
          size="small"
          v-model="submitCate.cateName.$value"
          placeholder=""
          maxlength="30"
          show-word-limit
        ></el-input>
        <span class="label">业态</span>
        <el-select
          v-model="submitCate.formatList.$value"
          collapse-tags
          filterable
          clearable
          multiple
          size="small"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in dict.formatList"
            :key="index"
            :label="item.cnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="label">角色归属</span>
        <el-select
          v-model="submitCate.roleBelonged.$value"
          size="small"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in dict.roleList"
            :key="index"
            :label="item.cnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cateDialog = false">取 消</el-button>
        <el-button type="primary" @click="addNewCate">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑分类"
      :visible.sync="cateEditVisible"
      v-loading="cateEditLoading"
      width="400px"
    >
      <el-form
        ref="form"
        :rules="cateEditRules"
        :model="cateEditForm"
        label-width="80px"
      >
        <el-form-item label="分类名称" prop="specName">
          <el-input
            v-model="cateEditForm.specName"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="业态" prop="formatList">
          <el-select
            v-model="cateEditForm.formatList"
            collapse-tags
            filterable
            value-key="formatId"
            clearable
            multiple
            size="small"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in dict.formatList"
              :key="index"
              :label="item.cnName"
              :value="item.model"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色归属" prop="roleItemId">
          <el-select
            v-model="cateEditForm.roleItemId"
            collapse-tags
            filterable
            size="small"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in dict.roleList"
              :key="index"
              :label="item.cnName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cateEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import roleTree from "./roleTree.vue";
import service from "@/xgzdService/setting-service";
import { promiseWrapper } from "@/utils/wrapper";
import { checkerGenerator, submitter } from "@/utils/submitter";
import { PRJ_ROLE } from "@/views/constant/role";
import checkHelper from "../mixins/checkHelper";
import { mapState } from "vuex";
import role from "@/CommonDP/service/privi-service";
import { getTreeData } from "@/CommonDP/utils/tree";
import { disablePrompt, checkPermission } from "@/CommonDP/utils/routeAuth";
const initRoleInfo = () => {
  return {
    roleName: {
      $value: "",
      checker: checkerGenerator("String", "角色名称不能为空"),
    },
    spec: {
      $value: "",
      checker: checkerGenerator("String", "所属分类不能为空"),
    },
    enterpriseId: {
      $value: "",
    },
  };
};

const initSubmitCate = () => {
  return {
    cateName: {
      $value: "",
      checker: checkerGenerator("String", "分类名称不允许为空"),
    },
    formatList: {
      $value: [],
      checker: checkerGenerator("Array", "业态不允许为空"),
    },
    roleBelonged: {
      $value: "",
      checker: checkerGenerator("String", "角色归属不允许为空"),
    },
  };
};

const initEditCateForm = () => {
  return {
    specName: "",
    specId: "",
    roleItemId: "",
    roleItemName: "",
    formatList: [],
  };
};
export default {
  mixins: [checkHelper],
  components: {
    roleTree,
  },
  data: () => {
    return {
      roleDialog: false,
      cateDialog: false,
      cateEditVisible: false,
      cateDialogLoading: false,
      roleDialogLoading: false,
      tableLoading: false,
      submitCate: initSubmitCate(),
      submitRole: initRoleInfo(),
      dict: {
        formatList: [],
        roleList: [],
        treeList: [],
      },
      node: null,
      roleType: PRJ_ROLE,
      initModuleTree: [],
      addPrjRoleUserConfig: checkPermission(":rolePowerConfig:addPrjRole"),
      addSpecConfig: checkPermission(":rolePowerConfig:addSpec"),
      cateEditForm: initEditCateForm(),
      cateEditLoading: false,
      cateEditRules: {
        specName: [
          {
            type: "string",
            required: true,
            message: "请输入分类名称",
            trigger: "change",
          },
        ],
        formatList: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个业态",
            trigger: "change",
          },
        ],
        roleItemId: [
          { required: true, message: "请选择角色归属", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    node: {
      handler(val) {
        if (val?.isCata) return;
        this.getPriviledges();
      },
      deep: true,
    },
    roleDialog: {
      handler(val) {
        this.submitRole = initRoleInfo();
      },
    },
    cateDialog: {
      handler(val) {
        this.submitCate = initSubmitCate();
      },
    },
    "cateEditForm.roleItemId": {
      handler(val) {
        this.cateEditForm.roleItemName =
          this.dict.roleList.find((item) => item.id === val)?.cnName || "";
      },
    },
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
    roleFormatCompute() {
      const specID = this.submitRole.spec.$value;
      if (!specID) return [];
      return (
        this.dict.treeList.find((item) => item.roleID === specID)?.formatList ||
        []
      ).map((item) => item.formatId);
    },
    roleBelongedCompute() {
      const specID = this.submitRole.spec.$value;
      if (!specID) return "";
      return this.dict.treeList.find((item) => item.roleID === specID)
        ?.roleItemId;
    },
    submitList() {
      return this.checkedItemCollector(this.moduleTree);
    },
    isDisabled() {
      return (
        JSON.stringify(this.initModuleTree) === JSON.stringify(this.submitList)
      );
    },
  },
  created() {
    this.getDict();
  },
  methods: {
    /** 显示 新增角色对话框 */
    newRole() {
      this.roleDialog = true;
    },

    /** 显示 新增分类对话框 */
    newCate() {
      this.cateDialog = true;
    },
    /** 回调 角色树节点点击回调 */
    nodeClick(data) {
      this.node = data;
      // debugger
    },
    /** 新增 分类 */
    addNewCate() {
      submitter(
        this.submitCate,
        async (res) => {
          let { specName, formatList: fkeyList, roleBelonged } = res;
          let formatList = fkeyList.map((key) => {
            let mapped = this.dict.formatList.find((item) => item.id === key);
            return {
              formatId: mapped?.id,
              formatName: mapped?.cnName,
            };
          });
          this.cateDialogLoading = true;
          const finalRes = await promiseWrapper(
            service.addItem({
              enterpriseId: this.enterpriseId,
              specName,
              formatList,
              roleItemId: roleBelonged,
              roleItemName: this.dict.roleList.find(
                (item) => item.id === roleBelonged
              )?.cnName,
            }),
            "[新增分类]"
          );
          this.cateDialogLoading = false;
          if (finalRes?.result == "0") {
            this.$message.success("新增分类成功");
            this.cateDialog = false;
            if (this.$refs["roleTree"]) {
              this.$refs["roleTree"].getTreeInfo();
              await this.getTreeDict();
            }
          }
        },
        { cateName: "specName" }
      );
    },
    /** 新增 角色 */
    addNewRole() {
      this.submitRole.enterpriseId.$value = this.enterpriseId;
      submitter(
        this.submitRole,
        async (res) => {
          this.roleDialogLoading = true;
          let finalRes = await promiseWrapper(
            service.addRole(res),
            "[新增项目角色]"
          );
          this.roleDialogLoading = false;
          if (finalRes?.result == "0") {
            this.$message.success("新增角色成功");
            this.roleDialog = false;
            if (this.$refs["roleTree"]) {
              this.$refs["roleTree"].getTreeInfo();
            }
          }
        },
        { spec: "specId" }
      );
    },
    /** 获取 页面所需字典 */
    async getDict() {
      let roleRes = await promiseWrapper(
        service.getRoleDict(),
        "[获取角色字典]"
      );
      let formatRes = await promiseWrapper(
        service.getFormatDict(),
        "[获取业态字典]"
      );

      this.dict.roleList = Array.isArray(roleRes?.data) ? roleRes?.data : [];
      this.dict.formatList = Array.isArray(formatRes?.data)
        ? formatRes?.data
        : [];
      this.dict.formatList.forEach(
        (item) =>
          (item.model = {
            formatName: item.cnName,
            formatId: item.id,
          })
      );
      await this.getTreeDict();
    },

    /** 初始化 角色树字典 */
    async getTreeDict() {
      //   debugger;
      let treeRes = await promiseWrapper(
        service.getPrjRoleTree(this.enterpriseId),
        "[获取角色树]"
      );
      this.dict.treeList = Array.isArray(treeRes?.data) ? treeRes?.data : [];
    },

    /**获取 项目权限 */
    async getPriviledges() {
      if (!this.node) return;
      const params = {
        roleId: this.node.roleID,
        businessType: this.roleType,
        enterpriseId: this.enterpriseId,
      };
      let res = await promiseWrapper(
        role.queryPermissionTreeForEnterpriseCheck(params),
        "[项目权限] 获取项目权限集合"
      );
      this.moduleTree = Array.isArray(res?.data) ? res?.data : [];
      getTreeData(this.moduleTree);
      this.refreshCheckboxStatus(this.moduleTree);
      /** 镜像备份以对比变化 */
      this.initModuleTree = JSON.parse(
        JSON.stringify(this.checkedItemCollector(this.moduleTree))
      );
    },

    /**收集器 已checked的节点*/
    checkedItemCollector(data) {
      if (!Array.isArray(data) || data.length <= 0) return [];
      let tempData = [];
      data.forEach((item) => {
        if (item.isChecked === 1) {
          tempData.push({
            permissionId: item.permissionId,
            isParentPage: item.isParentPage,
          });
        }
        tempData = [
          ...tempData,
          ...this.checkedItemCollector(item.childList),
          ...this.checkedItemCollector(item.buttonList),
        ];
      });
      return tempData;
    },

    /** 提交 权限变更 */
    async submitModulesHandler() {
      const a = disablePrompt();
      if (a) {
        const list = this.moduleTree;
        const roleID = this.node.roleID;
        let newarr = this.checkedItemCollector(list);
        const rolePermissionDetailList = newarr.map((item) => {
          return {
            permissionId: item.permissionId,
            isParentPage: item.isParentPage,
          };
        });
        const params = {
          enterpriseId: this.enterpriseId,
          roleId: roleID,
          rolePermissionDetailList,
        };
        const res = await role.addRolePermission(params);
        if (res.result === "0") {
          this.$message.success("保存成功");
        }
        this.getPriviledges(roleID);
        await this.$store.dispatch("GetModuleList", this.enterpriseId);
      }
    },
    editCategory(data) {
      this.cateEditForm.specName = data.roleName;
      this.cateEditForm.specId = data.roleID;
      this.cateEditForm.roleItemId = data.roleItemId;
      this.cateEditForm.roleItemName = data.roleItemName;
      this.cateEditForm.formatList = (data.formatList || []).map((item) => ({
        formatId: item.formatId,
        formatName: item.formatName,
      }));
      this.cateEditVisible = true;
    },
    submitEditForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.postUpdatedEditForm();
        } else {
          console.error("编辑分类表单校验失败!!");
          return false;
        }
      });
    },
    async postUpdatedEditForm() {
      this.cateEditLoading = true;
      let res = await promiseWrapper(
        service.updateClass({
          ...this.cateEditForm,
          enterpriseId: this.enterpriseId,
        }),
        "[项目权限] 更新分类信息"
      );
      this.cateEditLoading = false;
      if (res.result == "0") {
        this.$message.success("更新分类成功");
        if (this.$refs["roleTree"]) {
          this.$refs["roleTree"].getTreeInfo();
          await this.getTreeDict();
        }
        this.cateEditVisible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$left_width: 300px;
.prjRole {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  > * {
    height: 100%;
  }
  /deep/ .flexLayout {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    height: 100%;
    > span {
      margin-top: 20px;
      color: gray;
      font-size: 14px;
      font-weight: 300;
    }
  }
  &__layout {
    &-left {
      width: $left_width;
      box-sizing: border-box;
      padding: 10px 5px;
      border-right: 1px solid #f4f5fa;
      .dropdown {
        &:hover {
          color: blue;
          cursor: pointer;
        }
        * {
          font-size: 22px;
        }
      }
    }

    &-right {
      $header_height: 0px;
      width: calc(100% - #{$left_width});
      > * {
        padding: 20px;
        box-sizing: border-box;
        .header {
          display: flex;
          align-items: center;
          height: 30px;

          > span {
            font-size: 18px;
            font-weight: bold;
            margin-right: 10px;
          }
          /deep/ .el-button--small {
            border-radius: 20px;
          }
        }
        .detail {
          height: calc(100% - 30px);
          width: 100%;
          overflow: auto;
        }
      }
      &-tag {
        height: $header_height;
        width: 100%;
        border-bottom: 2px solid #f4fafa;
        display: flex;
        flex-flow: column nowrap;
      }
      &-perm {
        height: calc(100% - #{$header_height});
        width: 100%;
      }
    }
  }

  .submitForm {
    min-height: 250px;
    padding: 2px 10px 0px 10px;
    box-sizing: border-box;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    > span.label {
      margin: 20px 0px 5px 0px;
    }
    * {
      font-weight: 300 !important;
    }
  }
}
/deep/ td.table-module-name {
  $before-move: 22px;
  .cell {
    padding-left: $before-move + 3px !important;
    > .el-table__placeholder,
    > .el-table__expand-icon {
      margin-left: -$before-move - 1px !important;
    }
  }
}
.hasData {
  padding: 10px 0;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  .role-auth-project-list {
    flex-grow: 1;
    min-height: 0;
    overflow: auto;
    padding: 10px;
    box-sizing: border-box;
  }
  .role-auth-modules-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0px;
    flex-shrink: 0;
  }
}
</style>